import script from "./ChatLog.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatLog.vue?vue&type=script&setup=true&lang=js"

import "./ChatLog.vue?vue&type=style&index=0&id=fc513afc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc513afc"]])

export default __exports__